fx.ns("models", class ThemeLayoutComponent extends models.CreationElementContent {

	constructor(data)
	{
		super(data);
    }

    get defaults()
    {
        return { theme_layout_id : 0, rotation : 0};
    }

	get propertiesNotStorable()
    {
        return ["id"];
    }

    get isPhoto()
	{
		return this.component_type == "photo" || this.component_type == "image";
	}

	get isShape()
	{
		return this.component_type == "shape";
	}

	get isText()
	{
		return this.component_type == "text";
	}

	get isBackground()
	{
		return this.component_type == "background";
	}

	get isSticker()
	{
		return this.component_type == "sticker";
	}

  
});